import { Api, Auth } from '~/services'


export function getMainFeed() {
	return ( dispatch, getStore ) => {

		var data = {};
		if( Auth.getToken() ) data.secure_token = Auth.getToken()

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_MAIN_FEED'
				})

				Api.get( '/wp/feed/main', data, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_MAIN_FEED',
						posts: data
					})
				})
			}
		)

	}
}


export function getNewMainFeed( highestId ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;
		if( !highestId ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_NEW_MAIN_FEED'
				})

				Api.get( '/wp/feed/main/after/' + highestId, {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_NEW_MAIN_FEED',
						newPosts: data.newPosts
					})
					if( !!data.newReplies.length ) {
						for (var r = 0; r < data.newReplies.length; r++) {
							dispatch({
								type: 'RECEIVE_NEW_REPLY',
								statement: data.newReplies[r]
							})
						}
					}
				})
			}
		)

	}
}


export function getOlderMainFeed( number, offset ) {
	return ( dispatch, getStore ) => {
		
		if( !Auth.getToken() || !number || !offset ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_OLDER_MAIN_FEED'
				})

				Api.get( '/wp/feed/main/' + number + '/offset/' + offset, {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data.length || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_OLDER_MAIN_FEED',
						posts: data
					})
				})
			}
		)

	}
}


export function getCampFeed( campSlug ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;
		if( !campSlug ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_MAIN_FEED'
				})

				Api.get( '/wp/feed/camp/' + campSlug, {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_MAIN_FEED',
						posts: data
					})
				})
			}
		)

	}
}



export function getNewCampFeed( campSlug, highestId ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;
		if( !campSlug ) return;
		if( !highestId ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_NEW_MAIN_FEED'
				})

				Api.get( '/wp/feed/camp/' + campSlug + '/after/' + highestId, {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( !data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_NEW_MAIN_FEED',
						newPosts: data.newPosts
					})
					if( !!data.newReplies.length ) {
						data.newReplies.map(function(statement) {
							dispatch({
								type: 'RECEIVE_NEW_REPLY',
								statement: statement
							})
						})
					}
				})
			}
		)

	}
}


export function getOlderCampFeed( campSlug, number, offset ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() || !campSlug || !number || !offset ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_OLDER_MAIN_FEED'
				})

				Api.get( '/wp/feed/camp/' + campSlug + '/' + number + '/offset/' + offset, {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( !data || error ) return;
					dispatch({
						type: 'RECEIVE_OLDER_MAIN_FEED',
						posts: data
					})
				})
			}
		)

	}
}



export function emptyNewPosts() {
	return ( dispatch, getStore ) => {
		return dispatch(
			dispatch => {
				dispatch({
					type: 'EMPTY_NEW_MAIN_FEED'
				})
			}
		)
	}
}



export function resetAllPostsLoaded() {
	return ( dispatch, getStore ) => {
		return dispatch(
			dispatch => {
				dispatch({
					type: 'RESET_ALL_POSTS_LOADED'
				})
			}
		)
	}
}


export function getQuestionsFeed( ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_QUESTIONS_FEED'
				})

				Api.get( '/wp/feed/questions', {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_QUESTIONS_FEED',
						questions: data
					})
				})
			}
		)

	}
}



export function getNewQuestionsFeed( highestId ) {
	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		if( !highestId ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_QUESTIONS_FEED'
				})

				Api.get( '/wp/feed/questions/after/' + highestId, {
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data.length || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_NEW_QUESTIONS_FEED',
						posts: data
					})
				})
			}
		)

	}
}



// WEBPACK FOOTER //
// ./src/js/actions/feed.js